export default "/assets/d8ed0c683675a631.svg"